import React from 'react';

import styled from "styled-components";
import ALERT_MAP from "../../maps/alertMap";
import {Chip} from "@mui/material";
import {colors} from "../../maps/colors";
import IconBtn from "../IconBtn";
import Icn from "../Icn";

const WrapperStyled = styled.div`
    display: flex;
    justify-self: end;
    margin-right: 10px;
    align-items: center;

    border-radius: 4px;
    border-style: solid;
    border-width: 0px;
    border-color: rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23);
    position: relative;
    margin-top: 5px;
`;

const ItemStyled = styled.div`
    display: grid;
    margin-left: 20px;

    grid-template-columns: auto 1fr;
    align-items: center;
`;

const StatusStyled = styled.div`
    display: inline-block;
    margin-left: 6px;
`;

const NameStyled = styled.div`
    width: max-content;
    display: inline-block;
    font-size: 13px;
    color: ${colors.GRAY4};

    .wrapper-grid {
        display: grid;
        grid-template-columns: auto 1fr auto;
        align-items: center;
    }
`;

const EditStyled = styled.div`
    cursor: pointer;
    margin-left: 30px;
`;

const TitleStyled = styled.div`
    position: absolute;
    color: var(--mui-palette-text-secondary);
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 13px;
    line-height: 1.4375em;
    letter-spacing: 0.00938em;
    top: -10px;
    left: 17px;
    background: rgb(255, 255, 255);
    width: max-content;
    z-index: 1;
    padding: 0 7px;
`;

const AlertSettingsDisplay = ({item, type, openSettingsHandle, entType, siteSettings}) => {
    let alertSettings = item?.alertSettings;
    let settingsFrom = null;
    if(!alertSettings && entType === "field"){
        alertSettings = siteSettings;
        settingsFrom = 'Site';
    }

    return (
        <WrapperStyled>
            {settingsFrom && (
                <ItemStyled>
                    <NameStyled>
                        Settings from:
                    </NameStyled>
                    <StatusStyled>
                        {settingsFrom}
                    </StatusStyled>
                </ItemStyled>
            )}
            {ALERT_MAP.values.map(pp => {
                let isEnabled = true;
                let threshold = pp?.input?.threshold || 0;
                let isThreshold = !!pp?.input;

                let show = true;
                if (pp.limitedTo && entType) {
                    const isInList = pp.limitedTo.indexOf(entType);
                    if (isInList === -1) {
                        show = false;
                    }
                }

                if (!show) {
                    return null;
                }

                if (alertSettings?.[pp.code]) {
                    isEnabled = alertSettings?.[pp.code]?.isEnabled;

                    if (alertSettings[pp.code].threshold) {
                        threshold = alertSettings[pp.code].threshold;
                    }
                }

                return (
                    <ItemStyled key={pp.code}>
                        <NameStyled>
                            <div className="wrapper-grid">
                                <Icn
                                    style={{
                                        width: 15,
                                        height: 15
                                    }}
                                >{pp.icon}</Icn>
                                <span>
                                {pp.name}:
                                </span>
                                {isThreshold && (
                                    <span style={{marginLeft: 5}}>t: {threshold}</span>
                                )}
                            </div>
                        </NameStyled>
                        <StatusStyled>
                            <Chip
                                sx={{fontSize: 11}}
                                size="small"
                                label={isEnabled ? "On" : "Off"}
                                color={isEnabled ? 'success' : 'secondary'}
                                variant={isEnabled ? 'filled' : 'outlined'}
                            />
                        </StatusStyled>
                    </ItemStyled>
                );
            })}
            <EditStyled>
                <IconBtn
                    onClick={openSettingsHandle}
                    customtheme="small-gray"
                    size="small"
                    style={{color: colors.GRAY4}}
                >
                    edit
                </IconBtn>
            </EditStyled>
        </WrapperStyled>
    );
};

export default AlertSettingsDisplay;